import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'

import styles from './SidebarSectionsLoading.module.css'

export const SidebarSectionsLoading = () => {
  return (
    <div className={styles.sidebarSectionsLoadingContainer}>
      <IssuesLoadingSkeleton height="md" width="60%" />
      <IssuesLoadingSkeleton height="md" width="80%" />
      <IssuesLoadingSkeleton height="md" width="40%" />
      <IssuesLoadingSkeleton height="md" width="60%" />
      <IssuesLoadingSkeleton height="md" width="70%" />
      <IssuesLoadingSkeleton height="md" width="50%" />
    </div>
  )
}
